<template>
  <div>
    <TitleCard style="max-width: 97%; margin: 10px auto" title="店铺海报">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">Poster</li>
        </ul>
      </template>
    </TitleCard>
    <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="" style="margin-bottom: 10px;padding: 0px 30px;">
          <div class="card card-flush">
            <div class="card-body">
              <div
                  style="display: flex;justify-content: center;flex-direction: column;align-content: center;align-items: center;">
                <el-image :src="$store.getters.userInfo.balance"
                          :preview-src-list="[$store.getters.userInfo.balance]"
                          style="width: 300px"/>
                <div style="margin-top: 20px">
                  <el-icon class="el-icon-warning" style="font-size: 10px;" />
                  易拉宝（建议打印尺寸：80*180cm)
                </div>
                <div style="margin-top: 10px">
                  <el-icon class="el-icon-warning" style="font-size: 10px;" />
                  海报（建议打印尺寸：60*90cm)
                </div>
                <div style="margin-top: 20px">
                  <el-button @click="downloadThis">下载分享海报</el-button>
                  <el-button @click="downloadSourceMaterial">下载素材</el-button>
                  <el-button @click="downloadQrCode">下载二维码</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 5500px;min-height: 5500px; position: fixed; left: -9999px; top: -9999px;" id="content" >
      <QrCode :text="'https://xingyunsi.3jzc.cn/openShop?staffId='+$store.getters.userInfo.id" :size="5500" />
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 例如：import uploadFile from '@/components/uploadFile/uploadFile'

import html2canvas from "html2canvas";
import QrCode from "@/components/QrCode.vue";

export default {
  name: 'index',
  // import引入的组件需要注入到对象中才能使用
  components: {QrCode},
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    // 这里存放数据
    return {}
  },
  // 监听属性 类似于data概念
  computed: {},
  // 方法集合
  methods: {
    downloadSourceMaterial(){
      window.open("https://pan.baidu.com/s/1geF-wqzT_Gd_e3QsLpyL_g?pwd=cnwm")
    },
    downloadThis(){
      window.open(this.$store.getters.userInfo.balance)
    },
    async downloadQrCode() {
      const contentDiv = document.getElementById('content');
      const contentWidth = contentDiv.offsetWidth;
      const canvas = await html2canvas(contentDiv, {
        width: contentWidth, // Set the canvas width to match the content div's width
      });

      // Convert canvas to image
      const image = canvas.toDataURL('image/png');

      const a = document.createElement('a');
      a.href = image;
      a.download = 'content.png';
      a.click();
    },
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
//@import url(); 引入公共css类
</style>